import { useNavigate } from "react-router-dom";
import PlayButton from "../components/PlayButton";
import Title from "../components/Title";

const LandingPage = ({ title }: { title: string }) => {
  const navigate = useNavigate();
  return (
    <div className="landingpage-container">
      <Title title={title} />
      <hr />
      <p>Starte die Schnitzeljagd!</p>
      <PlayButton onClickHandler={() => navigate("hunt")} />
    </div>
  );
};

export default LandingPage;
